import { validarQtdeCaractere } from './auxiliares';
import { useMetadadosItem } from './useMetadadosItem';

export const useMetadadosPalavraChave = () => {
  const criterios = [
    { texto: 'A palavra-chave deve conter entre 1 e 60 caracteres', otimizado: false },
    { texto: 'Este campo não pode estar vazio', otimizado: false },
  ];

  function validacoes(index, palavraChave) {
    switch (index) {
      case 0:
        return validarQtdeCaractere(palavraChave, 1, 60);
      case 1:
        return palavraChave !== null && palavraChave !== undefined && palavraChave.length > 0;
    }
  }

  return useMetadadosItem({ itemCriterios: criterios, validacoesFn: validacoes });
};
